<script lang="ts">
  import { prefersReducedMotion } from 'svelte/motion';

  interface Props {
    visibles: boolean;
    destelloAgudo: number;
  }

  let { visibles, destelloAgudo }: Props = $props();

  /** Cantidad fija de partículas de polen. */
  const CANTIDAD = 80;

  /** Posiciones y velocidades iniciales pseudo-aleatorias (deterministas). */
  const PARTICULAS = Array.from({ length: CANTIDAD }, (_, i) => ({
    left: ((i * 41) % 100) + ((i * 7) % 13) / 13,
    delay: (i * 173) % 5000,
    duracion: 8000 + ((i * 91) % 4000),
    escala: 0.6 + ((i * 13) % 10) / 10,
  }));
</script>

{#if visibles}
  <div class="polen-contenedor" aria-hidden="true">
    {#each PARTICULAS as p, i}
      <span
        class="particula"
        style="
          left: {p.left}%;
          animation-delay: {p.delay}ms;
          animation-duration: {p.duracion}ms;
          transform: scale({p.escala});
        "
      ></span>
    {/each}
  </div>

  <!-- Destellos esporádicos según banda aguda -->
  {#if destelloAgudo > 0.7}
    <div class="destello" aria-hidden="true"></div>
  {/if}
{/if}

<style>
  .polen-contenedor {
    position: fixed;
    inset: 0;
    z-index: 5;
    pointer-events: none;
    overflow: hidden;
  }

  .particula {
    position: absolute;
    bottom: 0;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: var(--color-polen);
    box-shadow: 0 0 6px var(--color-polen);
    opacity: 0.7;
    animation: flotar linear infinite;
  }

  @keyframes flotar {
    0% {
      transform: translateY(0) translateX(0);
      opacity: 0;
    }
    10% {
      opacity: 0.8;
    }
    90% {
      opacity: 0.8;
    }
    100% {
      transform: translateY(-110vh) translateX(40px);
      opacity: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .particula {
      animation: none;
      opacity: 0.5;
      bottom: 50%;
    }
  }

  .destello {
    position: fixed;
    top: 30%;
    left: 50%;
    width: 200px;
    height: 200px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: radial-gradient(circle, var(--color-polen) 0%, transparent 70%);
    opacity: 0.4;
    z-index: 5;
    animation: destelloRapido 400ms ease-out;
  }

  @keyframes destelloRapido {
    from {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.5);
    }
    to {
      opacity: 0.4;
      transform: translate(-50%, -50%) scale(1.5);
    }
  }
</style>
